import { render, staticRenderFns } from "./QuotaItem.vue?vue&type=template&id=9c6efbd2&scoped=true&"
import script from "./QuotaItem.vue?vue&type=script&lang=js&"
export * from "./QuotaItem.vue?vue&type=script&lang=js&"
import style0 from "./QuotaItem.vue?vue&type=style&index=0&id=9c6efbd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6efbd2",
  null
  
)

export default component.exports